var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.user.hasRoles.includes("Archived Teacher")
        ? _c(
            "v-banner",
            { staticClass: "mb-1", attrs: { color: "soli-status-red" } },
            [
              _c("div", { staticClass: "white--text flex justify-center" }, [
                _vm._v(
                  "\n            This teacher has been archived\n        "
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-row",
        {
          staticClass: "pb-3 px-1 animate__animated animate__fadeIn",
          class: { "mt-1": _vm.$vuetify.breakpoint.xs },
          attrs: { dense: "" },
        },
        [
          _vm.can("View statistical reports")
            ? _c("SoliStats", {
                key: _vm.dateRange[0] + _vm.dateRange[1],
                attrs: {
                  activeMemberships:
                    _vm.studentHistory?.filter((e) => e.activeMemberships)
                      .length ?? null,
                  firstVisits:
                    _vm.studentHistory?.filter((e) => e.assessments).length ??
                    null,
                  enrollments:
                    _vm.studentHistory?.filter((e) => e.enrollments).length ??
                    null,
                  withdrawals:
                    _vm.studentHistory?.filter((e) => e.withdrawals).length ??
                    null,
                  links: false,
                  selected: _vm.statSelection,
                },
                on: {
                  click: function ($event) {
                    return _vm.filterStudents($event.filter)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "soli-round my-3" },
        [
          _c(
            "v-container",
            { staticClass: "px-3", attrs: { fluid: "" } },
            [
              _c("ReportHeader", {
                attrs: {
                  filter: "",
                  subtitle: "Current status of all students in this period",
                  dateRange: _vm.dateRange,
                  reportUrl: `/profile/${_vm.user.id}/student-history`,
                  dateOptions: "all, month, year",
                  monthSelector: "",
                },
                on: {
                  search: function ($event) {
                    _vm.search = $event
                  },
                },
              }),
              _vm._v(" "),
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.studentHistory || [],
                  "disable-pagination": "",
                  "hide-default-footer": "",
                  "show-select": "",
                  "mobile-breakpoint": "0",
                  loading: !_vm.studentHistory,
                  search: _vm.search,
                  "item-key": "option_id",
                },
                on: {
                  "click:row": function ($event) {
                    return _vm.$log($event.id)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "top",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "font-semibold soli-grey text-lg py-2 px-4",
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    `${
                                      _vm.selectedPeople.length
                                        ? `Selected: ${_vm.selectedPeople.length} `
                                        : `Total: ${
                                            _vm.studentHistory?.length ?? ""
                                          }`
                                    }`
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: `item.name`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex align-center py-2" },
                            [
                              _c(
                                "v-list-item-avatar",
                                {
                                  staticClass: "my-0",
                                  staticStyle: { float: "left" },
                                },
                                [
                                  _c("v-img", {
                                    attrs: { src: item.profile_photo_url },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "v-list-item-title",
                                    [
                                      _c(
                                        "Link",
                                        {
                                          attrs: {
                                            href: `/profile/${item.id}/account`,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.name) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-item-subtitle", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(item.email) +
                                        "\n                            "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.lesson`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex align-center py-2" },
                            [
                              _c(
                                "div",
                                [
                                  _c("v-list-item-title", [
                                    _c("small", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            item.lesson.group_event?.title ??
                                              item.lesson.instrument.name
                                          ) +
                                          "\n                                "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-list-item-subtitle", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(item.lesson.type) +
                                        "\n                            "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.status`,
                      fn: function ({ item }) {
                        return [_c("div", [_vm._v(_vm._s(item.status))])]
                      },
                    },
                    {
                      key: `item.start_date`,
                      fn: function ({ item }) {
                        return [
                          _c("div", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  item.start_date
                                    ? _vm.globalMomentDateDots(item.start_date)
                                    : null
                                ) +
                                "\n                    "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.end_date`,
                      fn: function ({ item }) {
                        return [
                          _c("div", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  item.end_date
                                    ? _vm.globalMomentDateDots(item.end_date)
                                    : null
                                ) +
                                "\n                    "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.withdraw_date`,
                      fn: function ({ item }) {
                        return [
                          _c("div", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  item.withdraw_date
                                    ? _vm.globalMomentDateDots(
                                        item.withdraw_date
                                      )
                                    : null
                                ) +
                                "\n                    "
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.selectedPeople,
                  callback: function ($$v) {
                    _vm.selectedPeople = $$v
                  },
                  expression: "selectedPeople",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }